import colors from './colors'
import icons from './icons'
import images from './images'

const R = {
  icons: icons,
  colors: colors,
  images: images,
}

export default R
